import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { CalendarPickerModalComponent } from '../helper/components/calendar-picker-modal/calendar-picker-modal.component';
import { CalendarComponent } from '../helper/components/calendar/calendar.component';
import { DateTimePickerComponent } from '../helper/components/date-time-picker/date-time-picker.component';
import { SharedModule } from './shared.module';
import { CustomPickerComponent } from '../helper/components/custom-picker/custom-picker.component';
import { DatePickerModalComponent } from '../helper/components/date-picker-modal/date-picker-modal.component';



@NgModule({
  imports: [
    IonicModule,
    FormsModule,
    CommonModule,
    TranslateModule,
    SharedModule
  ],
  declarations: [CalendarComponent, CalendarPickerModalComponent, DateTimePickerComponent,CustomPickerComponent,DatePickerModalComponent],
  exports: [CalendarComponent, CalendarPickerModalComponent, DateTimePickerComponent,CustomPickerComponent,DatePickerModalComponent]
})
export class CalendarPickerModule { }
